import classNames from 'classnames';
import { useCallback } from 'react';
import { Button } from 'yoso';
import {
  Adventure,
  useAdventure,
  useAdventureNextPrice,
  useProceedJoinAdventure,
} from '~/components/Adventure/Adventure.hooks';
import { useAdventureStatus } from '~/components/Adventure/Control/AdventureControl.hooks';
import { T } from '~/components/I18n';
import { format } from '~/components/Util/number';
import styles from './AdventureControl.module.scss';

export type AdventureControlProps = {
  id: Adventure['id'];
  className?: string;
};

export const AdventureControl = ({ id, className }: AdventureControlProps) => {
  const { data: adventure } = useAdventure(id);
  const { participation } = adventure || {};
  const { currentCount = 0, maxCount = 12 } = participation || {};
  const status = useAdventureStatus(adventure);
  const nextPrice = useAdventureNextPrice(id);

  const { mutate: proceed, opened } = useProceedJoinAdventure();
  const onClick = useCallback(
    (e) => {
      e.stopPropagation();
      proceed(id);
    },
    [id, proceed]
  );

  const disabled = status !== 'IN_PROGRESS' || currentCount >= maxCount;

  return (
    <Button
      className={classNames(styles.root, className, {
        [styles.opened]: opened,
      })}
      color="primary"
      size="large"
      disabled={disabled}
      onClick={onClick}
      data-event="click"
      data-event-category="explore"
      data-event-target="adventure_explore_join_btn">
      {(() => {
        switch (status) {
          case 'IN_PROGRESS':
            return currentCount >= maxCount ? (
              <T name="citizen_join_button_completed" options={[format(currentCount)]} />
            ) : (
              <T name="citizen_join_button_don_join_one" options={[format(nextPrice)]} />
            );
          case 'UPCOMING':
          case 'END':
          default:
            return <T name="citizen_join_button_closed" />;
        }
      })()}
    </Button>
  );
};
